module.exports = __webpack_public_path__ + "static/img/top_2_4.84422367.jpg";